<template>
  <div class="online">
    <div class="main" :style="{ height: isSmallScreen ? 425 + 'px' : '100%' }">
      <div class="content" :style="{ maxHeight: isSmallScreen ? 425 + 'px' : 684 + 'px' }">
        <!-- 左边模块 -->
        <div class="left-panel" style="display:none">
          <!-- 左边标题 -->
          <div class="left-header">
            <div class="user-info">
              <div class="user-avatar">
                <img src="@/assets/images/online/avatar.png" />
              </div>
              <div class="userinfo flex1 flex-column">
                <div class="username ellipsis">jd_159371mtb</div>
                <div class="tags"></div>
              </div>
            </div>
            <div class="search-bar">
              <el-input class="online-input" v-model="searchVal" placeholder="搜索最近联系人"
                prefix-icon="el-icon-search"></el-input>
            </div>
          </div>
          <!-- 左边内容 -->
          <div class="left-content">
            <div class="list-item" :class="currentIndex == index ? 'active' : ''" @click="changeStore(item, index)"
              v-for="(item, index) in 30" :key="index">
              <div class="avator">
                <img src="@/assets/images/online/logo.png" />
              </div>
              <div class="name ellipsis">京东客服</div>
              <div :class="currentIndex == index ? '' : 'yellow'" class="label">
                店铺
              </div>
            </div>
          </div>
        </div>
        <!-- 右边模块 -->
        <div class="right-panel flex1 flex_column">
          <!-- <div class="right-header">
              <div class="avatar">
                <img src="@/assets/images/online/logo.png" />
              </div>
              <div class="info">
                <div class="name">中原e购客服</div>
                <div class="description">中原e购为您服务</div>
              </div>
            </div> -->
          <div class="body flex1">
            <div class="chat flex_column">
              <div class="chat-wrap flex1">
                <div class="chat-wrapper" ref="main">
                  <div ref="content">
                    <div class="log-btn" v-if="pageTotal > backTotal" @click="onLoadMore">点击加载更多</div>
                    <div class="chat-content" v-for="(customer, index) in customerList" :key="index">
                      <div class="message--date" v-if="index == 0">{{ customer.messageShowTime }}</div>
                      <div class="message--date"
                        v-if="index > 0 && judgeTime(customer.messageTime, customerList[index - 1].messageTime)">
                        {{ customer.messageShowTime }}
                      </div>
                      <!--客服信息-->
                      <div class="message clearfix waiter-message"
                        v-if="customer.client == 2 && (customer.type == 1 || customer.type == 2)">
                        <!-- <div class="message--date">周六 11:22</div> -->
                        <div class="message--pin">中原e购客服</div>
                        <div class="message--container clearfix">
                          <div class="message--head bg_theme"><img src="@/assets/images/online/logo.png" /></div>
                          <div class="message--content clearfix">
                            <div class="message--wrapper">
                              <!-- 文本信息 -->
                              <div class="text-message clearfix">
                                <div class="msg-status"></div>
                                <div class="text-message--container" @click="onLookImg($event)"
                                  v-if="hasHtmlTags(customer.message)" v-html="customer.message"></div>
                                <div class="text-message--container" v-else>{{
                                  changeLine(customer.message) }}</div>
                              </div>
                            </div>
                            <div class="message--icon" style="display:none;"></div>
                          </div>
                        </div>
                      </div>
                      <!--客服信息-->
                      <div class="message clearfix waiter-message" v-if="customer.client == 2 && customer.type == 4">
                        <!-- <div class="message--date">周六 11:22</div> -->
                        <div class="message--pin">中原e购客服</div>
                        <div class="message--container clearfix">
                          <div class="message--head bg_theme"><img src="@/assets/images/online/logo.png" /></div>
                          <div class="message--content clearfix">
                            <div class="message--wrapper">
                              <!-- 图片信息 -->
                              <div class="img-message">
                                <el-image class="img-message--content" :src="$imgpath + customer.message"
                                  :preview-src-list="[$imgpath + customer.message]" @load="scrollToBottom"></el-image>
                              </div>
                            </div>
                            <div class="message--icon" style="display:none;"></div>
                          </div>
                        </div>
                      </div>
                      <!--用户信息-->
                      <div class="message clearfix customer-message"
                        v-if="customer.client == 1 && (customer.type == 1 || customer.type == 2)">
                        <!-- <div class="message--date">周六 11:22</div> -->
                        <!-- <div class="message--pin">京东智能客服</div> -->
                        <div class="message--container clearfix">
                          <div class="message--head"><img src="@/assets/images/online/avatar.png" /></div>
                          <div class="message--content clearfix">
                            <div class="message--wrapper">
                              <div class="text-message clearfix">
                                <div class="msg-status" v-if="customer.messageState == 0">已读</div>
                                <div class="msg-status" v-else>未读</div>
                                <div class="text-message--container" v-if="hasHtmlTags(customer.message)"
                                  v-html="customer.message"></div>
                                <div class="text-message--container" v-else>{{
                                  changeLine(customer.message) }}
                                </div>
                              </div>
                            </div>
                            <div class="message--icon" style="display:none;"></div>
                          </div>
                        </div>
                      </div>
                      <!--用户信息 订单的显示-->
                      <div class="message clearfix customer-message" @click="onorderdetail(customer.message.orderSn)"
                        v-if="customer.client == 1 && customer.type == 3">
                        <!-- <div class="message--date">周六 11:22</div> -->
                        <!-- <div class="message--pin">京东智能客服</div> -->
                        <div class="message--container clearfix">
                          <div class="message--head"><img src="@/assets/images/online/avatar.png" /></div>
                          <div class="message--content clearfix">
                            <div class="message--wrapper">
                              <!-- 模板信息 -->
                              <div class="tpl-message clearfix">
                                <div>
                                  <div class="single-temp send">
                                    <div class="send-title flex_bt send-title">
                                      <div class="ordernum">订单号：{{ customer.message.orderSn }}</div>
                                      <div class="ordertime">{{
                                        getdatatime(customer.message.createTimeStr)
                                      }}</div>
                                    </div>
                                    <div class="product-item clearfix">
                                      <div class="pic-wrap"><img :src="$imgpath + customer.message.goodsImage" /></div>
                                      <div class="info-wrap">
                                        <div class="title textTow">{{ customer.message.goodsName }}</div>
                                        <div class="label"></div>
                                        <div class="footer flex_bt flex_center">
                                          <div class="order-price">￥{{ customer.message.goodsTotalPrice }}</div>
                                          <div class="status" v-if="customer.message.orderState == 0">交易关闭</div>
                                          <div class="status" v-if="customer.message.orderState == 10">待支付</div>
                                          <div class="status" v-if="customer.message.orderState == 20">待发货</div>
                                          <div class="status" v-if="customer.message.orderState == 30">待收货</div>
                                          <div class="status" v-if="customer.message.orderState == 35">已收货</div>
                                          <div class="status status1" v-if="customer.message.orderState == 40">交易完成</div>
                                          <div class="status" v-if="customer.message.orderState == 98">申请取消</div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="message--icon" style="display:none;"></div>
                          </div>
                        </div>
                      </div>
                      <!--用户信息 图片的显示-->
                      <div class="message clearfix customer-message" v-if="customer.client == 1 && customer.type == 4">
                        <div class="message--container clearfix">
                          <div class="message--head"><img src="@/assets/images/online/avatar.png" /></div>
                          <div class="message--content clearfix">
                            <div class="message--wrapper">
                              <!-- 图片信息 -->
                              <div class="img-message">
                                <div class="msg-status" v-if="customer.messageState == 0">已读</div>
                                <div class="msg-status" v-else>未读</div>
                                <el-image class="img-message--content" :src="$imgpath + customer.message"
                                  :preview-src-list="[$imgpath + customer.message]" @load="scrollToBottom"></el-image>
                              </div>
                            </div>
                            <div class="message--icon" style="display:none;"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-field">
                <div>
                  <!-- 工具 -->
                  <div class="toolbar">
                    <el-upload class="avatar-uploader" name="files" action="/api/front-web-app/fileupload/fileUpload"
                      :show-file-list="false" :http-request="uploadCoverImg">
                      <div class="image"></div>
                    </el-upload>
                  </div>
                  <!-- 输入框 -->
                  <div class="send-box" ref="chatContainer" contenteditable @paste="handlePaste" @keydown="handleKeyDown">
                    <!-- <el-input type="textarea" ref="inputRef" :rows="2" class="sendbox" placeholder="" resize="none"
                      v-model="searchVal" @paste="paste" @keydown.native="Keydown">
                    </el-input> -->
                  </div>
                  <!-- 发送按钮 -->
                  <div class="input-btn">
                    <div class="inputbtn" @click="onSend">发送</div>
                    <!-- <div class="inputbtn" @click="captureScreenshot">截图</div> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- 订单 -->
            <div class="product-order flex1 flex_column">
              <!-- tabpanel -->
              <div class="order-tabs">
                <div class="tab-item ellipsis flex1" :class="orderIndex == 0 ? 'active' : ''" @click="changeOrder(0)">
                  猜你想问
                </div>
                <div class="tab-item ellipsis flex1" v-if="$store.state.login_status"
                  :class="orderIndex == 1 ? 'active' : ''" @click="changeOrder(1)">
                  我的订单
                </div>
              </div>
              <div class="product-order-wrap flex1">
                <!-- 正在咨询 -->
                <div class="product-info flex_column" v-if="orderIndex == 0">
                  <div class="underline-tabs">
                    <!-- <div class="underline-tabs-content">猜你想问</div> -->
                  </div>
                  <div class="product-list flex1">
                    <!-- 猜你想问 -->
                    <div class="common-question flex_center">
                      <img src="@/assets/images/online/guess.svg" />
                    </div>
                    <!-- 问题 -->
                    <div class="question-warpper flex_column">
                      <div class="question-list">
                        <div class="question-tab">
                          <div class="question-tab-box flex_center">
                            <div :class="questionTabIndex == index ? 'question-tab-item active' : 'question-tab-item'"
                              @click="onChangeType(index)" v-for="(item, index) in questionList">{{ item.type }}</div>
                          </div>
                        </div>
                        <div class="questions" v-if="questionList.length">
                          <div class="question-item" v-for="(question, index) in questionList[questionTabIndex].list"
                            @click="onQuestion(question)">
                            <div>{{ index + 1 }}、{{ question.question }}</div>
                            <div class="arrow"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 我的订单 -->
                <div class="orders-box flex_column" v-if="orderIndex == 1">
                  <div class="order-search">
                    <el-input class="orderinput" placeholder="请输入内容" @keyup.enter.native="onSearch"
                      v-model="formData.commonQuery">
                      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </div>
                  <div class="orders flex1" ref="scrollContainer" @scroll="handleScroll">
                    <div class="orderlist" v-for="(order, index) in orderLists" :key="index">
                      <div class="title flex_bt flex_center">
                        <span>订单号：{{ order.orderSn }}</span>
                        <!-- <span class="time">{{
                            getdatatime(order.createTimeStr)
                          }}</span> -->
                        <div class="consult" @click="onTotalOrderSend(order)">咨询订单</div>
                      </div>
                      <div class="productlist">
                        <div class="order_time fs12 fc_6 mart5">创建时间：{{
                          getdatatime(order.createTimeStr)
                        }}</div>
                        <div class="product-item" v-for="(goods, goodsIndex) in order.orderGoodsList">
                          <div class="img-box">
                            <img :src="$imgpath + goods.goodsImage" />
                          </div>
                          <div class="info flex1">
                            <div class="product-title textTow">{{ goods.goodsName }}</div>
                            <div class="btns">
                              <div class="send" @click="onOrderSend(order, goods)">发送</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="order-price flex_center flex_bt">
                        <div>订单金额：<span class="price">￥{{ order.orderTotalPrice }}</span></div>
                        <div class="status" v-if="order.orderState == 0">交易关闭</div>
                        <div class="status" v-if="order.orderState == 10">待支付</div>
                        <div class="status" v-if="order.orderState == 20">待发货</div>
                        <div class="status" v-if="order.orderState == 30">待收货</div>
                        <div class="status" v-if="order.orderState == 35">已收货</div>
                        <div class="status status1" v-if="order.orderState == 40">交易完成</div>
                        <div class="status" v-if="order.orderState == 98">申请取消</div>
                      </div>
                    </div>
                    <div class="loading" v-if="loading">正在加载中...</div>
                    <div class="loading" v-if="!hasMoreData">已加载完毕</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 图片预览 -->
      <el-image-viewer ref="imageViewer" v-if="showDialog" :url-list="[imageUrl]" hide-on-click-modal teleported
        :on-close="closePre" />
    </div>
  </div>
</template>
<script>
import { customerServiceList, commonQuestion } from '@/api/online.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { userTag } from '@/api/order'
import { formatDate } from '@/utils/my.js'
import dayjs from "dayjs";
import ScreenShort from "js-web-screen-shot";
const formData = {
  checknum: '',
  orderState: '',
  orderType: '1',
  applySn: '',
  buyerOrgId: '',
  buyerOrgName: '',
  orderSn: '',
  buyerName: '',
  storeName: '',
  supplierName: '',
  startTime: '',
  endTime: '',
  orderConfirm: '',
  checkInput: '',
  evaluationStatus: '',
  returnDataType: '2',
  lockState: '',
  trimeSter: '',
  pageNo: 1,
  pageSize: 10,
  goodsName: '',
  commonQuery: ''
}
export default {
  components: {
    ElImageViewer
  },
  data() {
    return {
      searchVal: "",
      currentIndex: 0,
      orderIndex: 0,
      isSmallScreen: false, //是否是小屏幕
      customerList: [],//用户和客户沟通的数据
      pageTotal: 0,//用户和客户沟通剩余的总数
      backTotal: 0,//本次调用接口返回的总数
      lastId: '',//加载用户和客户沟通数据的第一条记录的messageId
      isLoading: false, // 是否正在加载
      currentHeight: 0,//当前元素内容高度
      questionList: [],
      questionTabIndex: 0,
      formData: Object.assign({}, formData),
      orderLists: [],
      totalCount: 0,
      loading: false,//是否正在加载
      hasMoreData: true,//是否还有更多数据
      type: 0,
      showDialog: false,
      imageUrl: '',
      pastedImage: null,
      clipboardData: null
    };
  },
  computed: {
    //时间格式化
    getdatatime() {
      return function (time) {
        let date = new Date(time)
        let yy = date.getFullYear()
        let mm =
          date.getMonth() + 1 < 10
            ? '0' + (date.getMonth() + 1)
            : date.getMonth() + 1
        let dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
        let hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
        let mf =
          date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
        let ss =
          date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
        let gettime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
        return gettime
      }
    },
    //是否含有html标签
    hasHtmlTags() {
      return function (str) {
        let regex = /<[^>]+>/g;
        return regex.test(str);
      }
    }
  },
  mounted() {
    this.searchVal = '';
    setTimeout(() => {
      this.$globalSocket.connectWebSocket((result) => {
        console.log(result);
        if (result.type == 3) {//订单的发送
          result.message = JSON.parse(result.message);
        }
        this.customerList.push(result);
        this.customerList.map(item => {
          let messageShowTime = this.toggleTime(item.messageTime).time;
          item.messageShowTime = messageShowTime;
        })
        // if (this.type == 1) {
        //   this.searchVal = '';
        // }
        this.$nextTick(() => {
          if (this.$refs.main) {
            this.$refs.main.scrollTop = this.$refs.content.scrollHeight;
          }
        })
        this.$refs.chatContainer.innerHTML = '';
      });
    }, 500)
    //window.addEventListener('keydown', this.handleKeyDown);
  },
  destroyed() {
    //document.removeEventListener('paste', this.paste)
  },
  created() {
    if (window.screen.width <= 1366) {
      this.isSmallScreen = true;
    } else {
      this.isSmallScreen = false;
    }
    this.getCustomerServiceList();//获取用户咨询列表
    this.getCommonQuesttion();//获取通用的问题
    //document.addEventListener('paste', this.paste)
  },
  beforeDestroy() {
    // if (this.$globalSocket.socket) {
    //   this.$globalSocket.closeWebsocket();
    // }
  },
  methods: {
    changeLine(str) {
      return str.replace(/<br>/g, '\n')
    },
    handlePaste(event) {
      event.preventDefault();
      const clipboardData = event.clipboardData || window.clipboardData;
      const items = clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type.indexOf('image') !== -1) {
          const file = item.getAsFile();
          if (file) {
            this.handleImage(file);
          }
        } else if (item.type.indexOf('text') !== -1) {
          const text = event.clipboardData.getData('text/plain');
          document.execCommand("insertText", false, text);
          if (item.type.indexOf('text/plain') != -1) {
            break;
          }
        }
      }
      //this.clipboardData = this.$refs.chatContainer.innerHTML;
    },
    handleKeyDown(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.onSend();
      }
      if (event.ctrlKey && event.key === 'z') {
        event.preventDefault();
        this.$refs.chatContainer.innerHTML = this.clipboardData;
        this.focusToEnd();
      }
    },
    focusToEnd() {
      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(this.$refs.chatContainer);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
      this.$refs.chatContainer.focus();
    },
    // 粘贴
    paste(event) {
      // 文本----------------------------------------
      const text = (event.clipboardData || window.clipboardData).getData('text');
      if (text && text.trim()) {
        console.log('粘贴的文本', text);
        this.handleText(text);
        return;
      }
      // 图片----------------------------------------
      let image = null;
      const items = (event.clipboardData || window.clipboardData).items;
      if (!items || items.length === 0) return this.$message.error('当前浏览器不支持本地打开图片，请复制粘贴文本内容！');
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          image = items[i].getAsFile();
          break;
        }
      }
      if (image) {
        // console.log('粘贴的图片', image);
        this.handleImage(image);
        return;
      }
      if (!text || !image) return this.$message.error('请粘贴文本或图片');
    },
    handleText(d) {
      let aa = d
        .replace(/\n(\n)*( )*(\n)*\n/g, "\n")//去掉多余空行
        .split('\n');//每一行作为一条数据
      let r = [];
      for (let i = 0, len = aa.length; i < len; i++) {
        let a = aa[i].trim().replace(/\s+/g, " ");//将连续多余空格缩减为一个空格
        a && r.push(a.split(" "));
      }
    },
    handleImage(d) {
      const reader = new FileReader();
      reader.onload = e => {
        let src = this.base64toFile(e.target.result, 'file')
        let formData = new FormData();
        formData.append('files', src, src.name);
        this.$http({
          url: "/api/front-web-app/fileupload/fileUpload",
          method: "post",
          headers: {
            "content-type": "multipart/form-data",
          },
          data: formData,
        })
          .then((response) => {
            if (response.data.success) {
              let url = response.data.result;
              url = url.slice(1, url.length);
              const imgElement = document.createElement('img');
              imgElement.src = this.$imgpath + url;
              imgElement.style.maxWidth = '200px'; // 设置最大宽度为200px
              imgElement.style.maxHeight = '200px';
              this.insertImageAtCursor(imgElement);
              //this.$refs.chatContainer.appendChild(imgElement);
              imgElement.addEventListener('dblclick', () => {
                this.showDialog = true;
                this.imageUrl = imgElement.src;
              });
              this.focusToEnd();
            }
          })
          .catch((error) => { });
      };
      reader.readAsDataURL(d);
    },
    insertImageAtCursor(imgElement) {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        range.deleteContents();
        range.insertNode(imgElement);
      }
    },
    base64toFile(data, fileName) {
      const dataArr = data.split(',')
      const byteString = atob(dataArr[1])
      const options = {
        type: 'image/jpeg',
        endings: 'native',
      }
      const u8Arr = new Uint8Array(byteString.length)
      for (let i = 0; i < byteString.length; i++) {
        u8Arr[i] = byteString.charCodeAt(i)
      }
      return new File([u8Arr], `${fileName}.jpg`, options) // 返回文件流
    },
    Keydown(e) {
      if (!e.shiftKey && e.keyCode == 13) {
        e.cancelBubble = true; //ie阻止冒泡行为
        e.stopPropagation();//Firefox阻止冒泡行为
        e.preventDefault(); //取消事件的默认动作*换行
        //以下处理发送消息代码
        this.onSend();
      }
    },
    //控制弹出框滚动条
    controlScroll() {
      this.$nextTick(() => {
        if (this.$refs.main) {
          this.$refs.main.scrollTop = this.$refs.content.scrollHeight;
        }
      })
      //window.addEventListener('keydown', this.handleKeyDown);
    },
    //发送
    onSend() {
      const chatContent = this.$refs.chatContainer.innerHTML;
      if (chatContent) {//表示输入的有值
        this.dealImg(chatContent);
      }
      return;
      if (this.searchVal) {
        this.sendMessage(this.searchVal, 1);
      }
    },
    dealImg(str) {
      if (str.indexOf('img') > -1) {
        const regexStyle = /<img[^>]*src="([^"]+)"[^>]*>/g;
        const filteredContent = str.replace(regexStyle, (match, src) => {
          return `<img src="${src}">`;
        });
        const regex = /<img src="(.*?)">/g;
        const matches = filteredContent.matchAll(regex);

        const result = [];
        let lastIndex = 0;

        for (const match of matches) {
          const imgSrc = match[1];
          const text = filteredContent.substring(lastIndex, match.index);

          result.push({ type: 'text', content: text });
          result.push({ type: 'image', src: imgSrc });

          lastIndex = match.index + match[0].length;
        }

        // 处理剩余的文字
        if (lastIndex < filteredContent.length) {
          const text = filteredContent.substring(lastIndex);
          result.push({ type: 'text', content: text });
        }
        result.map(item => {
          if (item.type == 'text') {
            if (item.content && item.content != '<br>') {
              this.sendMessage(item.content, 1);
            }
          } else {
            item.src = item.src.replace(this.$imgpath, '');
            this.sendMessage(item.src, 4);
          }
        })
      } else {
        //console.log('没有图片但是有换行符：' + chatContent);
        this.sendMessage(str, 1);
      }
    },
    //sendMessage 发送消息 type用来标志是否把seachVal的值置空
    sendMessage(message, type) {
      this.$globalSocket.sendWebSocketMessage({ message: message, type: type });
      if (type == 1) {
        this.type = 1;
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        if (this.$refs.main) {
          this.$refs.main.scrollTop = this.$refs.content.scrollHeight;
        }
      });
    },
    //猜你想问咨询问题
    onQuestion(question) {
      //这个是猜你想问问题的时候  规定传2
      this.sendMessage(question.question, 2);
    },
    //根据不同时间的消息，输出不同的时间格式
    toggleTime(date) {
      let time;
      let type = this.getDateDiff(date);
      //1：新消息，2：当天消息,3：昨天消息，4：今年消息，5：其他消息
      if (type == 1) {
        time = "以下为最新消息";//新消息，不显示时间，但是要显示"以下为最新消息"
      } else if (type == 2) {
        time = dayjs(date).format("H:mm");//当天消息，显示：10:22
      } else if (type == 3) {
        time = dayjs(date).format("昨天 H:mm");//昨天消息，显示：昨天 20:41
      } else if (type == 4) {
        time = dayjs(date).format("M月D日 AH:mm").replace("AM", "上午").replace("PM", "下午");//今年消息，上午下午，显示：3月17日 下午16:45
      } else if (type == 5) {
        time = dayjs(date).format("YYYY年M月D日 AH:mm").replace("AM", "上午").replace("PM", "下午");//其他消息，上午下午，显示：2020年11月2日 下午15:17
      }
      return {
        time: time,
        type: type
      };
    },
    //判断消息类型
    getDateDiff(date) {
      let nowDate = dayjs(new Date());//当前时间
      let oldDate = dayjs(new Date(date));//参数时间
      let result;
      if (nowDate.year() - oldDate.year() >= 1) {
        result = 5;
      } else if (nowDate.month() - oldDate.month() >= 1 || nowDate.date() - oldDate.date() >= 2) {
        result = 4;
      } else if (nowDate.date() - oldDate.date() >= 1) {
        result = 3;
      } else if (nowDate.hour() - oldDate.hour() >= 1 || nowDate.minute() - oldDate.minute() >= 5) {
        result = 2;
      } else {
        result = 1;
      }
      return result;
    },
    //判断两个时间间隔相差
    judgeTime(time1, time2) {
      let date1 = new Date(time1);
      let date2 = new Date(time2);
      let diff = Math.abs(date1.getTime() - date2.getTime());
      var diffMinutes = Math.ceil(diff / (1000 * 60));
      // 判断时间差是否小于30分钟
      if (diffMinutes < 30) {
        return false;
      } else {
        return true;
      }
    },
    //获取通用的问题
    getCommonQuesttion() {
      commonQuestion({}).then(res => {
        if (res.success) {
          this.questionList = res.data;
        }
      })
    },
    //改变猜你想问的类型
    onChangeType(index) {
      this.questionTabIndex = index;
    },
    //点击加载更多用户咨询列表
    onLoadMore() {
      this.getCustomerServiceList(2);
    },
    //获取用户咨询列表 type传具体的值表示点击加载更多
    getCustomerServiceList(type) {
      if (this.loading) return;
      this.isLoading = true;
      let originHeight = 0;//记录加载数据之前的高度
      this.$nextTick(() => {
        originHeight = this.$refs.content.scrollHeight;
      })
      customerServiceList({
        memberId: this.$cookie.get("wsmemberId"),
        lastId: this.lastId,
        client: 1,
        pageSize: 10
      }).then((res) => {
        console.log(res);
        if (res.success) {
          let result = res.pager.result;
          if (result.length > 0) {
            this.lastId = result[0].messageId;
          }
          let data = result;
          data.map(item => {
            let messageShowTime = this.toggleTime(item.messageTime).time;
            item.messageShowTime = messageShowTime;
            if (item.client == 1 && item.type == 3) {//表示用户 订单
              item.message = JSON.parse(item.message)
            }
          })
          this.customerList = [...data, ...this.customerList];
          this.backTotal = data.length;//本次接口返回的数据数
          this.pageTotal = res.pager.totalRows;//本页还剩余多少数据
          if (!type) {
            this.$nextTick(() => {
              this.$refs.main.scrollTop = this.$refs.content.scrollHeight;
            })
          } else {
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.main.scrollTop = this.$refs.content.scrollHeight - originHeight+20;
                console.log('加载数据之后的高度：' + this.$refs.main.scrollTop);
              },100)
            })
            // this.$nextTick(() => {
            //   this.$refs.main.scrollTop = this.$refs.main.scrollHeight - originHeight + 80;
            // })
          }
        }
        this.isLoading = false; // 标记加载完成
      }).catch(err => {
        this.isLoading = false; // 标记加载完成
      })
    },
    //切换
    changeStore(item, index) {
      this.currentIndex = index;
    },
    //切换订单
    changeOrder(index) {
      this.orderIndex = index;
      this.formData.pageNo = 1;
      this.totalCount = 0;
      this.orderLists = [];
      this.getUserTag();
    },
    //获取我的订单
    getUserTag() {
      //如果正在加载或者没有更多数据，则不在加载
      if (this.loading || !this.hasMoreData) return;
      let params = this.formData;
      //设置正在加载状态
      this.loading = true;
      userTag(params).then((result) => {
        console.log(result)
        this.orderLists = this.orderLists.concat(result.pager.result);
        this.totalCount = result.pager.totalRows;
        // 更新页码
        this.formData.pageNo++;
        // 设置加载完成状态
        this.loading = false;
        if (this.totalCount === this.orderLists.length) {
          this.hasMoreData = false;
        }
      })
    },
    //我的订单发送
    onOrderSend(order, goods) {
      console.log(order);
      console.log(goods);
      let params = {};
      params.orderSn = order.orderSn;
      params.createTimeStr = order.createTimeStr;
      params.goodsImage = goods.goodsImage;
      params.goodsName = goods.goodsName;
      params.orderTotalPrice = order.orderTotalPrice;
      params.orderState = order.orderState;
      params.goodsPrice = goods.goodsPrice;
      params.goodsNum = goods.goodsNum;
      params.goodsTotalPrice = Number(goods.goodsPrice) * Number(goods.goodsNum)
      //这个是我的订单 发送  规定传3
      this.sendMessage(JSON.stringify(params), 3);
    },
    //咨询总计订单
    onTotalOrderSend(order) {
      let time = formatDate(new Date(order.createTimeStr), 'yyyy-MM-dd hh:mm:ss');
      this.sendMessage('订单于' + time + '创建，订单号：' + order.orderSn + '，请购单号：' + order.applySn, 1);
    },
    //查看详情
    onorderdetail(orderSn) {
      let routeUrl = this.$router.resolve({
        path: "/orderdetail",
        query: { orderSn: orderSn }
      });
      window.open(routeUrl.href, '_blank');
    },
    //处理滚动事件
    handleScroll() {
      const container = this.$refs.scrollContainer;
      if ((container.scrollTop + container.clientHeight) >= container.scrollHeight && this.hasMoreData) {
        this.getUserTag();
      }
    },
    //按下enter键搜索
    onSearch() {
      this.formData.pageNo = 1;
      this.totalCount = 0;
      this.orderLists = [];
      this.loading = false;
      this.hasMoreData = true;
      this.getUserTag();
    },
    // 自定义上传图片
    uploadCoverImg(file) {
      console.log(file);
      let formData = new FormData();
      formData.append(file.filename, file.file, file.file.name);
      this.$http({
        url: "/api/front-web-app/fileupload/fileUpload",
        method: "post",
        headers: {
          "content-type": "multipart/form-data",
        },
        data: formData,
      })
        .then((response) => {
          if (response.data.success) {
            let url = response.data.result;
            url = url.slice(1, url.length);
            console.log(url);
            this.sendMessage(url, 4);
          }
        })
        .catch((error) => { });
    },
    //点击查看大图
    onLookImg(e) {
      if (e.target.localName == 'img') {
        this.showDialog = true;
        this.imageUrl = e.target.currentSrc;
      }
    },
    //关闭查看的大图
    closePre() {
      this.showDialog = false
    },
    captureScreenshot() {
      let that = this;
      const screenShotHandler = new ScreenShort({
        enableWebRtc: false,  //是否显示选项框
        level: 99,  //层级级别
        completeCallback: function (imageData) {
          const arr = imageData.base64.split(',');
          const mime = arr[0].match(/:(.*?);/)[1];
          const bstr = atob(arr[1]);
          let n = bstr.length;
          const u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          const blob = new Blob([u8arr], { type: mime });
          const file = new File([blob], 'filename.png', { type: mime });
          that.uploadCoverImg(file)
        },
        closeCallback: function () {
          // const img = document.querySelector('img');
          // if (img) {
          //   img.parentNode.removeChild(img);
          // }
        },
      });
    },
    insertTextAtCursor(text) {
      const chatContainer = this.$refs.chatContainer;
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);
      range.deleteContents();
      const textNode = document.createTextNode(text);
      range.insertNode(textNode);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
      chatContainer.focus();
    }
  },
};
</script>
<style>
.el-image-viewer__wrapper {
  z-index: 9999 !important;
  /* 调整ElImageViewer组件的优先级 */
}
</style>
<style scoped lang="scss">
br {
  margin: 0;
  padding: 0;
}

.br-wrapper {
  display: inline-block;
  margin: 0;
  padding: 0;
}

/deep/ .online-input {
  .el-input__prefix {
    color: #999 !important;
    top: -5px;
  }

  .el-input__inner {
    padding-left: 30px !important;
    border-radius: 5px;
  }
}

/deep/ .orderinput {
  .el-input {
    width: 91%;
  }

  .el-input__prefix {
    color: #999 !important;
    top: -2px;
    left: -3px;
    font-size: 18px;
  }

  .el-input__inner {
    height: 40px;
    line-height: 40px;
    border: 0;
    border-bottom: 1px solid #ebebeb;
    padding-left: 25px !important;
  }
}

/deep/ .sendbox {
  .el-textarea__inner {
    border: 0;
    background-color: transparent;
  }
}

.online {
  height: 100%;

  .main {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    height: 100%;

    .content {
      //   width: 1130px;
      width: 935px;
      min-height: 420px;
      max-height: 796px;
      margin: 0 auto;
      background: #fff;
      border-radius: 5px;
      box-sizing: border-box;
      display: flex;

      .left-panel {
        width: 250px;
        display: flex;
        flex-direction: column;

        .left-header {
          box-sizing: border-box;
          padding: 10px;
          background: #ff534c;
          background-image: linear-gradient(-139deg, #ff534c, #ff3737);

          .user-info {
            display: flex;

            .user-avatar {
              width: 50px;
              height: 50px;
              border-radius: 4px;
              overflow: hidden;
              margin-right: 10px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .username {
              font-size: 18px;
              color: #fff;
              letter-spacing: 0;
            }
          }

          .search-bar {
            width: 230px;
            height: 24px;
            box-sizing: border-box;
            margin-top: 10px;
          }
        }

        .left-content {
          border-right: 1px solid #e7e7e7;
          flex: 1;
          overflow: hidden;
          overflow-y: auto;

          .list-item {
            box-sizing: border-box;
            padding: 10px;
            font-size: 13px;
            background: #f2f5f9;
            user-select: none;
            display: flex;
            cursor: pointer;

            .avator {
              width: 20px;
              height: 20px;
              margin-right: 10px;

              img {
                width: 100%;
                height: 100%;
                overflow: hidden;
              }
            }

            .name {
              flex: 1;
              color: #1c2229;
            }

            .label {
              font-size: 12px;
              border-radius: 2px;
              padding: 0 4px;
              color: #fff;
              height: 18px;
              background: #f23030;
              margin-top: 2px;
            }

            .yellow {
              background: #ffc267;
            }
          }

          .active {
            font-size: 14px;
            background: #d2e6f9;

            .avator {
              width: 30px;
              height: 30px;
              margin-right: 10px;

              img {
                width: 100%;
                height: 100%;
                overflow: hidden;
              }
            }
          }
        }
      }

      .right-panel {
        overflow: hidden;
        width: 935px;

        .right-header {
          width: 100%;
          height: 60px;
          background: #fafafa;
          box-sizing: border-box;
          padding: 10px;
          display: flex;

          .avatar {
            width: 40px;
            height: 40px;
            border-radius: 3px;
            overflow: hidden;
            margin-right: 10px;
            background: #e63535;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .info {
            padding-top: 3px;

            .name {
              font-size: 14px;
              color: #343036;
            }

            .description {
              color: #a1a6af;
              font-size: 12px;
            }
          }
        }

        .body {
          display: flex;
          overflow: hidden;

          .chat {
            width: 550px;
            border-right: 1px solid #e7e7e7;
            background-color: #fafafa;
            box-sizing: border-box;

            .chat-wrap {
              box-sizing: border-box;
              overflow: hidden;
              width: 100%;
              background: #fff;
              border-top: 1px solid #e7e7e7;

              .chat-wrapper {
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                overflow-x: hidden;
                overflow-y: auto;
                padding: 20px;
                background-color: #fff;

                .log-btn {
                  font-size: 12px;
                  color: #5a606b;
                  margin-bottom: 12px;
                  text-align: center;
                  cursor: pointer;
                }

                .message--date {
                  font-size: 13px;
                  color: #a1a6af;
                  text-align: center;
                  margin-bottom: 13px;
                }

                .chat-content {
                  .message {
                    margin-bottom: 20px;
                  }

                  .message--pin {
                    box-sizing: border-box;
                    font-size: 12px;
                    color: #a1a6af;
                    padding: 0 48px;
                    margin-bottom: 3px;
                    width: 100%;
                    text-align: center;
                  }

                  .msg-status {
                    font-size: 12px;
                    padding-right: 8px;
                    max-width: 64px;
                    display: flex;
                    flex-shrink: 0;
                    align-items: flex-end;
                    color: #a1a6af;
                  }

                  .text-message--container {
                    background-color: #f3f3f3;
                    min-height: 18px;
                    line-height: 1.4;
                    border-radius: 4px;
                    padding: 12px 9px;
                    word-break: break-all;
                    position: relative;

                    &:after {
                      position: absolute;
                      content: "";
                      width: 23px;
                      height: 42px;
                      top: 0;
                    }
                  }

                  .message--container {
                    box-sizing: border-box;

                    .message--head {
                      margin-right: 10px;
                      width: 32px;
                      height: 32px;
                      border-radius: 3px;
                      overflow: hidden;

                      img {
                        width: 100%;
                        height: 100%;
                      }
                    }

                    .message--content {
                      position: relative;

                      .message--wrapper {
                        max-width: 391px;

                        .text-message {
                          min-height: 42px;
                          font-size: 13px;
                          line-height: 1.4;
                          box-sizing: border-box;
                          color: #252525;
                          letter-spacing: 0;
                          display: flex;
                        }
                      }
                    }
                  }

                  .waiter-message {
                    .message--head {
                      margin-right: 10px;
                      float: left;
                    }

                    .message--pin {
                      text-align: left;
                    }

                    .text-message--container {
                      margin-left: 5px;
                      padding-left: 17px;
                      text-align: justify;

                      &:after {
                        left: -6px;
                        background-image: url('../../assets/images/online/ts-arrow.png')
                      }
                    }

                    .message--wrapper {
                      float: left;
                    }

                    .img-message {
                      position: relative;
                      overflow: hidden;
                      padding-left: 5px;
                      display: flex;
                      margin-left: 5px;

                      &:after {
                        position: absolute;
                        content: "";
                        width: 23px;
                        height: 42px;
                        top: 0;
                        left: 0px;
                        background-image: url('../../assets/images/online/ts-arrow.png')
                      }

                      .img-message--content {
                        float: left;
                        margin-right: 5px;
                        background-color: #f3f3f3;
                        border-radius: 4px;
                        padding: 10px;
                        // min-width: 100px;
                        // min-height: 100px;
                        max-width: 200px;
                        max-height: 200px;
                        cursor: pointer;
                        z-index: 2;
                      }
                    }
                  }

                  .customer-message {
                    .message--head {
                      float: right;
                      margin-left: 10px;
                    }

                    .message--wrapper {
                      float: right;
                    }

                    .text-message--container {
                      float: right;
                      margin-right: 5px;
                      padding-right: 17px;
                      background-color: #d0e9ff;

                      &:after {
                        right: -6px;
                        background-image: url('../../assets/images/online/customer-arrow.png')
                      }
                    }

                    .img-message {
                      position: relative;
                      overflow: hidden;
                      padding-left: 5px;
                      display: flex;

                      &::after {
                        right: -1px;
                        background-image: url('../../assets/images/online/customer-arrow.png');
                        position: absolute;
                        content: "";
                        width: 23px;
                        height: 42px;
                        top: 0;
                        z-index: 1;
                      }

                      .img-message--content {
                        float: right;
                        margin-right: 5px;
                        background-color: #d0e9ff;
                        border-radius: 4px;
                        padding: 10px;
                        // min-width: 100px;
                        // min-height: 100px;
                        max-width: 200px;
                        max-height: 200px;
                        cursor: pointer;
                        z-index: 2;
                      }
                    }
                  }
                }
              }
            }

            .input-field {
              box-sizing: border-box;
              width: 100%;
              // height: 130px;
              height: 154px;
              padding-bottom: 10px;
              border-top: 1px solid #e7e7e7;
              background: #fff;

              .toolbar {
                box-sizing: border-box;
                height: 32px;
                margin-bottom: 5px;
                padding: 12px 0 0 20px;
                width: 100%;

                .image {
                  background-image: url("../../assets/images/online/all.png");
                  background-position: -410px -390px;
                  width: 18px;
                  height: 18px;
                  cursor: pointer;
                }

                .image:hover {
                  background-position: -382px -390px;
                }
              }

              .send-box {
                box-sizing: border-box;
                // height: 56px;
                height: 80px;
                color: #252525;
                font-size: 13px;
                white-space: normal;
                padding: 10px 15px;
                overflow: auto;
                outline: none;
              }

              .input-btn {
                display: flex;
                justify-content: flex-end;

                .inputbtn {
                  width: 60px;
                  margin-right: 10px;
                  text-align: center;
                  height: 25px;
                  line-height: 25px;
                  border: 1px solid #d9d9d9;
                  border-radius: 4px;
                  color: #343036;
                  font-size: 12px;
                  cursor: pointer;
                }
              }
            }
          }

          .product-order {
            box-sizing: border-box;

            .order-tabs {
              height: 42px;
              background-color: #f8f8f8;
              display: flex;

              .tab-item {
                box-sizing: border-box;
                height: 42px;
                line-height: 42px;
                border-bottom: 1px solid #e7e7e7;
                text-align: center;
                color: #5a606b;
                font-size: 12px;
                cursor: pointer;
                user-select: none;
                border-top: 1px solid #e7e7e7;
              }

              .active {
                background-color: #fff;
                border-bottom: 0 none;
                color: #f23030;
                border-top: 2px solid #f23030;
              }
            }

            .product-order-wrap {
              overflow: hidden;

              .product-info {
                height: 100%;
                box-sizing: border-box;

                .underline-tabs {
                  box-sizing: border-box;
                  border-bottom: 1px solid #e7e7e7;

                  .underline-tabs-content {
                    width: 66px;
                    margin: 0 auto;
                    padding-bottom: 9px;
                    border-bottom: 2px solid #f23030;
                    color: #5a606b;
                    font-size: 14px;
                    cursor: pointer;
                    user-select: none;
                  }
                }

                .product-list {
                  overflow: hidden;
                  height: 281px;
                  display: flex;

                  .common-question {
                    padding: 16px;
                    border-right: 1px solid rgba(0, 0, 0, 0.1);

                    img {
                      width: 40px;
                      max-width: 40px;
                    }
                  }

                  .question-warpper {
                    flex: 1 0;
                    overflow: auto;

                    .question-list {
                      flex: 1;
                      overflow-y: auto;

                      .question-tab {
                        color: rgba(0, 0, 0, 0.85);
                        border-bottom: 1px solid rgba(0, 0, 0, 0.1);

                        .question-tab-box {
                          transition: all 200ms linear;
                          overflow-x: scroll;
                          -ms-overflow-style: none;
                          scrollbar-width: none;
                          padding: 0 16px;

                          .question-tab-item {
                            font-size: 15px;
                            margin-right: 16px;
                            padding-bottom: 9px;
                            padding-top: 12px;
                            cursor: pointer;
                            border-bottom: 3px solid #fff;
                          }

                          .active {
                            color: rgb(44, 124, 246);
                            border-bottom: 3px solid rgb(44, 124, 246);
                          }
                        }

                        .question-tab-box::-webkit-scrollbar {
                          display: none;
                          /* Chrome Safari */
                        }
                      }

                      .questions {
                        overflow-y: auto;
                        width: 100%;
                        transition: all 600ms linear;

                        .question-item {
                          margin: 0 12px;
                          color: rgba(0, 0, 0, 0.65);
                          display: flex;
                          align-items: flex-start;
                          justify-content: space-between;
                          cursor: pointer;
                          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                          padding: 12px 2px;
                          font-size: 12px;

                          &:hover {
                            color: #2c7cf6;
                          }

                          .arrow {
                            width: 6px;
                            height: 6px;
                            border-top: 2px solid rgba(0, 0, 0, 0.15);
                            border-right: 2px solid rgba(0, 0, 0, 0.15);
                            transform: rotate(45deg);
                            margin-top: 5px;
                          }
                        }
                      }
                    }
                  }
                }
              }

              .orders-box {
                height: 100%;
                overflow: hidden;
                background: #faf9f9;

                .order-search {
                  width: 100%;
                  height: 40px;
                  padding: 0 10px;
                  box-sizing: border-box;
                  background: #fff;
                  display: flex;
                }

                .orders {
                  overflow-y: auto;
                  background: #faf9f9;

                  .orderlist {
                    font-size: 13px;
                    padding: 0 10px;
                    color: #5a606b;
                    margin-bottom: 10px;
                    background: #fff;

                    .title {
                      padding: 10px 0 8px;
                      border-bottom: 1px solid #f2f2f2;

                      .time {
                        color: #a1a6af;
                      }

                      .consult {
                        background: #e63535;
                        color: #fff;
                        font-size: 12px;
                        padding: 4px 6px;
                        border-radius: 14px;
                        cursor: pointer;
                      }
                    }

                    .productlist {
                      .product-item {
                        padding: 10px 0;
                        border-bottom: 1px solid #f2f2f2;
                        display: flex;

                        .img-box {
                          width: 80px;
                          height: 80px;
                          cursor: pointer;
                          border: 1px solid #f2f2f2;
                          margin-right: 10px;

                          img {
                            width: 80px;
                            height: 80px;
                            cursor: pointer;
                          }
                        }

                        .info {
                          font-size: 12px;
                          color: #1c2229;
                          line-height: 20px;

                          .product-title {
                            height: 38px;
                            cursor: pointer;
                          }

                          .btns {
                            display: flex;
                            justify-content: flex-end;

                            .send {
                              background: #faf9f9;
                              border: 1px solid #d9d9d9;
                              margin-top: 20px;
                              height: 20px;
                              line-height: 20px;
                              text-align: center;
                              border-radius: 4px;
                              padding: 0 12px;
                              cursor: pointer;
                            }
                          }
                        }
                      }
                    }

                    .order-price {
                      padding: 10px 0;

                      .price {
                        color: #f02b2b;
                      }

                      .status {
                        background: #f2f2f2;
                        color: #5a606b;
                        border-radius: 2px;
                        font-size: 12px;
                        padding: 4px 11px;
                      }
                    }

                    .status1 {
                      color: #f23030 !important;
                      background: #ffeded !important;
                    }
                  }

                  .loading {
                    text-align: center;
                    margin-bottom: 10px;
                    font-size: 12px;
                    color: #333;
                  }
                }
              }
            }
          }
        }
      }
    }

    .copyright {
      color: #fff;
      width: 100%;
      text-align: center;
      position: absolute;
      left: 0;
      bottom: 10px;
      font-size: 12px;
    }
  }
}

.clearfix {
  *zoom: 1;
}

.clearfix:after,
.clearfix:before {
  display: table;
  content: " ";
}

.clearfix:after {
  clear: both;
}

.order-intelligence {
  width: 310px;
  background: #fff;
  border: 1px solid #e5e5e5;
  padding: 10px 10px 0 10px;
  border-radius: 5px;

  .order-info {
    margin-bottom: 12px;

    .order-num {
      display: flex;
      justify-content: space-between;
      margin-bottom: 9px;
      color: #999;
      font-size: 12px;
    }

    .order-intro {
      display: flex;
      padding: 7px;
      height: 74px;
      box-sizing: border-box;
      background: #f5f5f5;
      border-radius: 4px;
      cursor: pointer;

      .intro-left {
        .product-img {
          width: 60px;
          height: 60px;
        }
      }

      .intro-right {
        margin-left: 10px;
        font-size: 12px;

        .right-title {
          width: 200px;
          white-space: nowrap;
          color: #151515;
        }

        .right-price {
          margin-top: 4px;
          color: #252525;
        }

        .right-time {
          display: flex;
          justify-content: space-between;
          margin-top: 7px;
          color: #999;
          width: 204px;
        }
      }
    }
  }

  .order-guess {
    .guess-title {
      display: flex;

      img {
        width: 93px;
        height: 27px;
      }
    }

    .guess-content {
      width: 100%;

      .content-item {
        display: flex;
        justify-content: space-between;
        height: 16px;
        border-top: 1px dashed #d7d7d7;
        padding: 10px 3px;
        color: #000;
        cursor: pointer;

        .item-left {
          max-width: 290px;
          font-size: 12px;
        }

        .item-right {
          background-image: url('../../assets/images/online/all.png');
          background-position: -501px -266px;
          width: 6px;
          height: 11px;
        }
      }
    }
  }
}

.single-temp {
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  padding: 0 18px;
  width: 400px;

  .send-title {
    padding: 10px 0;
    font-size: 12px;

    .ordernum {
      color: #5a606b;
    }

    .ordertime {
      color: #a1a6af;
    }
  }

  .footer {
    font-size: 12px;

    .order-price {
      color: #999;
    }

    .status {
      background: #f2f2f2;
      color: #5a606b;
      border-radius: 15px;
      font-size: 12px;
      padding: 4px 11px;
    }

    .status1 {
      color: #f23030 !important;
      background: #ffeded !important;
    }
  }
}

.single-temp-waiter {
  border-bottom: 1px solid #f2f2f2;
}

.send {
  float: right;
}

.product-item {
  padding: 0;
  padding-bottom: 10px;
  cursor: pointer;

  .pic-wrap {
    float: left;
    width: 80px;
    height: 80px;

    img {
      width: 100%;
      max-height: 100%;
    }
  }

  .info-wrap {
    float: left;
    width: 260px;
    margin-left: 10px;

    .title {
      font-size: 12px;
      height: 28px;
      line-height: 1.2;
    }
  }
}

.label {
  font-size: 12px;
  border-radius: 2px;
  display: inline-block;
  padding: 0 4px;
  line-height: 16px;
  color: #fff;
  background: #f23030;
}

.info-box {
  font-size: 13px;
  margin-top: 12px;
  color: #999;
  display: inline-block;
}

.product-single {
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  width: 400px;
  padding: 0 20px;
}

.send-url {
  height: 40px;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
  color: #a1a6af;

  span {
    font-size: 12px;

    &:after {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      border-right: 1px solid #0083ff;
      border-bottom: 1px solid #0083ff;
      margin-left: 8px;
      transform: rotate(-45deg);
    }
  }
}

.menu-wrap {
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  width: 400px;
  padding: 10px 10px 0 10px;
  font-size: 13px;
  color: #5a606b;

  .menu-title {
    line-height: 21px;
    margin-bottom: 8px;
    font-size: 12px;
  }

  .item2 {
    height: 40px;
    line-height: 40px;
    position: relative;
    cursor: pointer;
    border-top: 1px solid #f2f2f2;
    font-size: 12px;

    &:after {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      border-right: 1px solid #a1a6af;
      border-bottom: 1px solid #a1a6af;
      margin-left: 8px;
      transform: rotate(-45deg);
      position: absolute;
      right: 5px;
      top: 18px;
    }
  }
}
</style>
<style scoped lang="scss">
.message--wrapper {
  .text-message--container {

    >>>p,
    >>>div {

      img {
        height: auto;
        max-width: 100%;
      }
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/online/index.vue